/* global require */

export default [
  {
    name: 'American Express',
    slug: 'amex',
    website: 'https://americanexpress.com',
    logo: require('images/logos/amex-logo.svg'),
  },
  {
    name: 'Annette Dauphinais',
    slug: 'annette-dauphinais',
    website: 'https://annette.dauphina.is',
  },
  {
    name: 'Dr. Casey Seideman',
    slug: 'dr-casey-seideman',
    website: 'https://seidemanmd.com',
  },
  {
    name: 'Ansell',
    slug: 'ansell',
    website: 'http://ansell.com',
    logo: require('images/logos/ansell-logo.svg'),
  },
  {
    name: 'Camerama',
    slug: 'camerama',
    website: '/portfolio/camerama',
    logo: require('images/logos/camerama-logo.jpg'),
  },
  {
    name: 'Codewars',
    slug: 'codewars',
    website: 'https://codewars.com',
    logo: require('images/logos/codewars-logo.png'),
  },
  {
    name: 'Care Connectivity Consortium',
    slug: 'ccc',
    website: 'http://careconnectivity.org',
    logo: require('images/logos/ccc-logo.png'),
  },
  {
    name: 'Colby Dauphinais',
    slug: 'colby-dauphinais',
    website: 'https://colby.dauphina.is',
  },
  {
    name: 'DirecTV',
    slug: 'directv',
    website: 'https://directv.com',
    logo: require('images/logos/directv-logo.png'),
  },
  {
    name: 'Freelance',
    slug: 'freelance',
    website: null,
    logo: null,
  },
  {
    name: 'IHS',
    slug: 'ihs',
    website: 'https://ihs.com',
    logo: require('images/logos/ihs-logo.png'),
  },
  {
    name: 'Insperity',
    slug: 'insperity',
    website: 'https://insperity.com',
    logo: require('images/logos/insperity-logo.jpg'),
  },
  {
    name: 'Kaiser Permanente',
    slug: 'kp',
    website: 'https://kaiserpermanente.org',
    logo: require('images/logos/kp-logo.svg'),
  },
  {
    name: 'Lazard',
    slug: 'lazard',
    website: 'https://lazard.com',
    logo: require('images/logos/lazard-logo.svg'),
  },
  {
    name: 'Nike',
    slug: 'nike',
    website: 'https://nike.com',
    logo: require('images/logos/nike-logo.svg'),
  },
  {
    name: 'Reserve',
    slug: 'reserve',
    website: 'https://reserve.com',
    logo: require('images/logos/reserve-logo.png'),
  },
  {
    name: 'Tigerspike',
    slug: 'tigerspike',
    website: 'https://tigerspike.com',
    logo: require('images/logos/tigerspike-logo.jpg'),
  },
  {
    name: 'Saks Fifth Avenue',
    slug: 'saks',
    website: 'https://saks.com',
    logo: require('images/logos/saks-logo.jpg'),
  },
  {
    name: 'Sungevity',
    slug: 'sungevity',
    website: 'http://sungevity.com',
    logo: require('images/logos/sungevity-logo.png'),
  },
];



// WEBPACK FOOTER //
// ./src/data/companies.js